<template>
  <div class="page page--fill">
    <data-list
      title="Programmes"
      :resource="resource"
      :columns="columns"
      :filters="filters">
      <template #summary>
        <kpi-row :items="kpis" />
      </template>
      <template #name="{ item }">
        <div class="cell-strong">
          {{ item.name }}
        </div>
        <div class="cell-muted">
          {{ item.address && [item.address.zip_code, item.address.city].filter(Boolean).join(' ') }}
        </div>
      </template>
      <template #status="{ item }">
        <span :class="pillClass(PROGRAM_STATUS, item.status)">{{ labelOf(PROGRAM_STATUS, item.status) }}</span>
      </template>
      <template #promoteur="{ item }">
        <router-link
          v-if="item.promoteur"
          class="cell-link"
          :to="{ name: 'accountVue', params: { id: item.promoteur.pk } }">
          {{ item.promoteur.name }}
        </router-link>
      </template>
      <template #diffusion="{ item }">
        <span
          v-if="item.diffusion_enabled"
          class="pill pill--info">Diffusé</span>
        <span
          v-if="item.site_enabled"
          class="pill pill--violet ml-1">Site</span>
      </template>
    </data-list>
  </div>
</template>

<script>
  import RESOURCES from '@batimentb/vadimm-js-api/resources'
  import DataList from '../components/DataList'
  import KpiRow from '../components/KpiRow'
  import { PROGRAM_STATUS, YES_NO, toOptions, pillClass, labelOf, formatDate } from '../labels'

  export default {
    name: 'ProgramList',
    components: { DataList, KpiRow },
    data () {
      return {
        kpis: [
          { label: 'Programmes', resource: RESOURCES.PROGRAM, params: {} },
          { label: 'Disponibles', resource: RESOURCES.PROGRAM, params: { status: 'available' } },
          { label: 'Brouillons', resource: RESOURCES.PROGRAM, params: { status: 'draft' } },
          { label: 'Diffusés', resource: RESOURCES.PROGRAM, params: { diffusion_enabled: '1' } }
        ],
        PROGRAM_STATUS,
        resource: RESOURCES.PROGRAM,
        columns: [
          { key: 'name', label: 'Programme' },
          { key: 'status', label: 'Statut', width: 130 },
          { key: 'promoteur', label: 'Promoteur' },
          { key: 'diffusion', label: 'Diffusion', width: 160 },
          { key: 'created_on', label: 'Créé le', width: 110, format: formatDate }
        ],
        filters: [
          { key: 'searchable_name', type: 'search', label: 'Rechercher un programme' },
          { key: 'address__city', type: 'search', label: 'Ville', width: 200 },
          { key: 'status', type: 'select', label: 'Statut', items: toOptions(PROGRAM_STATUS) },
          { key: 'promoteur', type: 'remote', label: 'Promoteur', resource: RESOURCES.ACCOUNT },
          { key: 'diffusion_enabled', type: 'select', label: 'Diffusé', items: YES_NO }
        ]
      }
    },
    methods: {
      pillClass,
      labelOf
    }
  }
</script>
